module.exports = __webpack_public_path__ + "media/images/frontend/covid19_02-1cbd492b9029073ec1b602e8df65ec5f.jpg";